import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center mb-2 me-3"
}
const _hoisted_3 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_4 = { class: "fs-7" }
const _hoisted_5 = {
  class: "text-muted fw-bold d-block fs-7 text-end",
  dir: "ltr"
}
const _hoisted_6 = { class: "d-flex flex-column mb-2 me-3" }
const _hoisted_7 = { class: "me-3 fs-7 text-gray-700" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "تاریخ :", -1)
const _hoisted_9 = { class: "pe-1" }
const _hoisted_10 = { class: "me-3 fs-7 text-gray-700" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "وضعیت :", -1)
const _hoisted_12 = { class: "p-1" }
const _hoisted_13 = { class: "mb-10" }
const _hoisted_14 = {
  class: "d-flex align-items-center fs-6",
  style: {"width":"fit-content","position":"absolute","left":"5px","bottom":"5px"}
}
const _hoisted_15 = ["id", "onClick"]
const _hoisted_16 = ["id", "onClick"]
const _hoisted_17 = {
  key: 0,
  class: "card h-lg-100 mt-5"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column justify-content-center align-items-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/media/illustrations/sigma-1/15-dark.png",
      class: "h-200px h-lg-250px my-n6",
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("h3", { class: "mt-10" }, "هیچ پیام نیاز به بررسی وجود ندارد.")
  ])
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  class: "d-flex justify-content-center flex-stack flex-wrap",
  dir: "ltr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_Date = _resolveComponent("Date")!
  const _component_FileViewer = _resolveComponent("FileViewer")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
      return (_openBlock(), _createBlock(_component_el_card, {
        key: item.id,
        style: {"position":"relative"},
        class: "mt-5"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (item.bot && item.user)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_UserAvatar, {
                    avatar: item.user.picture,
                    size: "25px",
                    id: item.user.id
                  }, null, 8, ["avatar", "id"]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(item.user.first_name) + " " + _toDisplayString(item.user.last_name), 1),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(item.user.mobile), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("strong", _hoisted_9, [
                  _createVNode(_component_Date, {
                    date: item.created_at
                  }, null, 8, ["date"])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("strong", _hoisted_12, _toDisplayString(_ctx.translate(item.status)), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.messages, (msg) => {
              return (_openBlock(), _createElementBlock("div", {
                key: msg.id,
                class: "border border-1 border-dashed border-gray-400 bg-light-primary rounded p-3 m-5"
              }, [
                _createElementVNode("div", null, _toDisplayString(msg.message), 1),
                (msg.attachment_file)
                  ? (_openBlock(), _createBlock(_component_FileViewer, {
                      key: 0,
                      file: msg.attachment_file,
                      type: msg.message_type
                    }, null, 8, ["file", "type"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              class: "btn btn-success btn-sm m-1",
              id: 'btn' + item.id,
              onClick: ($event: any) => (_ctx.restricted_action('confirm' , item.id))
            }, "تایید", 8, _hoisted_15),
            _createElementVNode("button", {
              class: "btn btn-danger btn-sm m-1",
              id: 'r-btn' + item.id,
              onClick: ($event: any) => (_ctx.restricted_action('reject' , item.id))
            }, "رد پیام", 8, _hoisted_16)
          ])
        ]),
        _: 2
      }, 1024))
    }), 128)),
    (_ctx.list && _ctx.list.length < 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      (_ctx.pagination && _ctx.pagination.total_pages > 1)
        ? (_openBlock(), _createBlock(_component_el_pagination, {
            key: 0,
            background: "",
            layout: "prev, pager, next",
            class: "mt-4 mb-4",
            total: _ctx.pagination.total,
            currentPage: _ctx.pagination.current_page,
            "page-size": _ctx.pagination.per_page,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange
          }, null, 8, ["total", "currentPage", "page-size", "onSizeChange", "onCurrentChange"]))
        : _createCommentVNode("", true)
    ])
  ]))
}